import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { tokenStore } from '@/auth/token';
import { z } from 'zod';
import { APP_ROUTES } from '@/const/routes';

const LoginPage = lazy(() =>
  import('@/features/auth/login/LoginPage').then((m) => ({ default: m.LoginPage })),
);

const loginSearchSchema = z.object({
  reason: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: () => {
    if (tokenStore.get()) {
      throw redirect({ to: APP_ROUTES.app.index });
    }
  },
  component: () => (
    <Suspense>
      <LoginPage />
    </Suspense>
  ),
});
